import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import BAITable from "./BAITable";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de l'indice d'adiposité corporelle";
const DESCRIPTION =
  "Calculatrice de l en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de l, calculatrice de l, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/bai-calculator/";
function BAIcalculator() {
  const [height, setHeight] = useState();
  const [hipCircumference, setHipCircumference] = useState();
  const [gender, setGender] = useState("male");
  const [age, setAge] = useState();
  const [result, setResult] = useState();
  const [classification, setClassification] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      setError("");
      setResult("");
      if (age < 20) {
        setError("L'indice d'adiposité corporelle est destiné aux personnes de plus de 20 ans");
        return;
      }
      const heightInMeters = height / 100;
      const BAI = hipCircumference / Math.pow(heightInMeters, 1.5) - 18;
      setResult(BAI.toFixed(2));
      if (gender === "female") {
        if (age >= 20 && age <= 39) {
          if (BAI < 21) setClassification("Poids insuffisant");
          else if (BAI >= 21 && BAI <= 33) setClassification("Sain");
          else if (BAI > 33 && BAI <= 39) setClassification("Surpoids");
          else if (BAI > 39) setClassification("Obésité");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 23) setClassification("Poids insuffisant");
          else if (BAI >= 23 && BAI <= 35) setClassification("Sain");
          else if (BAI > 35 && BAI <= 41) setClassification("Surpoids");
          else if (BAI > 41) setClassification("Obésité");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 25) setClassification("Poids insuffisant");
          else if (BAI >= 25 && BAI <= 38) setClassification("Sain");
          else if (BAI > 38 && BAI <= 43) setClassification("Surpoids");
          else if (BAI > 43) setClassification("Obésité");
        }
      } else if (gender === "male") {
        if (age >= 20 && age <= 39) {
          if (BAI < 8) setClassification("Poids insuffisant");
          else if (BAI >= 8 && BAI <= 21) setClassification("Sain");
          else if (BAI > 21 && BAI <= 26) setClassification("Surpoids");
          else if (BAI > 26) setClassification("Obésité");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 11) setClassification("Poids insuffisant");
          else if (BAI >= 11 && BAI <= 23) setClassification("Sain");
          else if (BAI > 23 && BAI <= 29) setClassification("Surpoids");
          else if (BAI > 29) setClassification("Obésité");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 13) setClassification("Poids insuffisant");
          else if (BAI >= 13 && BAI <= 25) setClassification("Sain");
          else if (BAI > 25 && BAI <= 31) setClassification("Surpoids");
          else if (BAI > 31) setClassification("Obésité");
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculez précisément votre indice d'adiposité corporelle (IAC) et facilement!
                  Grâce à notre calculatrice avancée, vous pouvez déterminer avec précision votre
                  indice d'adiposité corporelle (IAC) en quelques secondes. Il vous suffit d'entrer
                  des mesures simples telles que le tour de hanche et la taille, et vous obtiendrez
                  immédiatement un résultat détaillé. Cette calculatrice a été développée sur la base
                  des dernières recherches scientifiques dans le domaine de la mesure de la graisse
                  corporelle, ce qui garantit l'exactitude et la fiabilité des résultats.
                </p>
                <p>
                  Pourquoi l'indice IAC est-il important? L'indice d'adiposité corporelle (IAC) est
                  une mesure plus précise pour estimer le pourcentage de graisse corporelle par rapport
                  à l'indice de masse corporelle traditionnel (IMC), en particulier pour les personnes
                  obèses ou maigres. Connaître votre indice IAC vous aide à suivre vos progrès vers un
                  poids sain et à le maintenir, et à prendre des décisions éclairées concernant votre
                  régime alimentaire et votre exercice physique.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-groupitems-center">
                      <label className="form-label ms-2" htmlFor="age">
                        Entrez l'âge
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Entrez l'âge"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="gender">
                        Choisir le sexe
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">Homme</option>
                        <option value="female">Femme</option>
                      </select>
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="height">
                        Entrez la taille
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="height"
                          type="number"
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          placeholder="Entrez la taille"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">cm</span>
                      </div>
                    </div>
                    <div className="form-group items-center">
                      <label
                        className="form-label ms-2"
                        htmlFor="hipCircumference"
                      >
                        Entrez le tour de hanche
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="hipCircumference"
                          type="number"
                          value={hipCircumference}
                          onChange={(e) => setHipCircumference(e.target.value)}
                          placeholder="Entrez le tour de hanche"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">cm</span>
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Indice d'adiposité corporelle: {result}</p>
                      <p>Classification: {classification}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que l'IAC ?</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Avantages de l'IAC</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BAIcalculator;
